import PersonalEmployeeProfile from "@/modules/personal/stores/profile/personal_employee_profile_store";

export default {
  modules: { PersonalEmployeeProfile },
};
